import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { getIsHotelOnly, getIsMobile } from 'src/store/view/selectors';
import { SearcherResults } from './SearcherResults';

import {
  getSearcherState,
  getHasOffersForCurrentDate,
  getOffersForCurrentDateWithMealsFilters,
  getOffersForCurrentDateWithAllHotelFilters,
} from '../../store/selectors/searcher';
import { hasRooms } from '../../store/selectors/rooms';
import { setEmptySearcherAction } from '../../store/actions/searcher';

const mapStateToProps = (state) => ({
  state: getSearcherState(state),
  hasOffers: hasRooms(state),
  hasOffersForCurrentDate: getHasOffersForCurrentDate(state),
  hasOffersForCurrentDateWithFilters: getIsHotelOnly(state)
    ? !isEmpty(getOffersForCurrentDateWithAllHotelFilters(state))
    : !isEmpty(getOffersForCurrentDateWithMealsFilters(state)),
  isHotelOnly: getIsHotelOnly(state),
  isMobile: getIsMobile(state),
});

const mapDispatchToProps = {
  emptyResultLoad: setEmptySearcherAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(SearcherResults);
